import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const tallevastConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Tallevast Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Tallevast, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_tallevast',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Tallevast',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Tallevast Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide dependable tree care to residential 
     and commercial properties throughout <strong>Tallevast</strong>. Situated in the 
     heart of the Sarasota Manatee corridor, this community deals with the same storm 
     pressure, fast tree growth, and seasonal hazards as the rest of Southwest Florida. 
     When overgrown or storm damaged trees start threatening your property, our team is 
     ready to handle it quickly and safely.`,

    `We specialize in <strong>hazardous tree removal and professional trimming</strong> 
     from large limbs overhanging structures to leaning trees damaged by storms, diseased 
     or rotting trunks that need full removal, and canopy overgrowth that creates 
     unnecessary liability. We execute every job with care and leave your property clean.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable tree care across 
     <strong>Tallevast</strong> and surrounding communities in <strong>Manatee and 
     Sarasota County</strong> keeping your property safe and your trees well-maintained 
     through every season.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Tallevast, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Tallevast = () => <LocationPage config={tallevastConfig} />;
export default Services_Tallevast;
